import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import ReportWidget from './ReportWidget';
import LoadingPage from '../LoadingPage';
import Chart from '../../util/chart';

class SMP2Widget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isReady: false,
    };

    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    this.reportOptions =
      process.env.NODE_ENV === 'development'
        ? ['', '1/1/19', '1/1/20', '', '', '']
        : ['', moment(firstDay).format('MM/DD/YY'), moment(lastDay).format('MM/DD/YY'), '', '', ''];
  }

  getData(data) {
    const ret = {};
    const final = [];
    const fields = ['postedHrs', 'excludedHrs', 'costHrs', 'soldHrs', 'dedHrs', 'netHrs'];
    data.forEach(v => {
      if (ret[v.mecno]) {
        fields.forEach(f => {
          ret[v.mecno][f] += parseFloat(v[f]);
        });
      } else {
        ret[v.mecno] = {};
        ret[v.mecno].name = v.name;
        fields.forEach(f => {
          ret[v.mecno][f] = parseFloat(v[f]);
        });
      }
    });
    _.forEach(ret, (v, k) => {
      const tmp = {};
      tmp.category = `${k} - ${v.name}`;
      fields.forEach(f => {
        tmp[f] = v[f];
      });
      final.push(tmp);
    });

    return final;
  }

  getGraphs() {
    const autoColor = Chart.autoColor();
    const ret = [];
    const fields = {
      postedHrs: 'Posted Hours',
      excludedHrs: 'Excluded Hours',
      costHrs: 'Cost Hours',
      soldHrs: 'Sold Hours',
      dedHrs: 'Deducted Hours',
      netHrs: 'Net Hours',
    };
    _.forEach(fields, (v, k) => {
      ret.push(
        Chart.getBarGraph({
          balloonText: "<span style='font-size:12px'><b>[[title]]</b> [[value]]</span>",
          fillColors: [autoColor()],
          id: k,
          title: v,
          valueField: k,
        })
      );
    });
    return ret;
  }

  handleData = ({ data, cols }) => {
    // transform array of positional data to array of json objects
    data.forEach((row, i) => {
      const obj = {};
      row.forEach((col, j) => {
        if (cols[j]) {
          obj[cols[j].name] = col;
        }
      });
      data[i] = obj;
    });

    this.setState(
      {
        data1: this.getData(data),
        graphs1: this.getGraphs(data),
        isReady: true,
      },
      this.renderCharts
    );
  };

  renderCharts() {
    Chart.makeBarChart('smp2-widget-chart-1', {
      dataProvider: this.state.data1,
      graphs: this.state.graphs1,
      rotate: true,
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
      },
      valueAxes: [
        {
          stackType: 'regular',
          title: 'Hours',
          axisAlpha: 0.3,
          gridAlpha: 0,
        },
      ],
      numberFormatter: {
        precision: 2,
      },
      titleField: 'label',
      labelRadius: 15,
      categoryField: 'category',
    });
  }

  render() {
    return (
      <ReportWidget pageName="SMP2" reportOptions={this.reportOptions} handleData={this.handleData}>
        {this.state.isReady ? <div id="smp2-widget-chart-1" className="carousel-cell" /> : <LoadingPage />}
      </ReportWidget>
    );
  }
}

export default SMP2Widget;
